// custom events for pushstate and replacestate

const pushState = () => new CustomEvent('pushstate', {});
const replaceState = paramsOnly => new CustomEvent('replacestate', { detail: { paramsOnly } });
const pushParams = () => new CustomEvent('pushparams', {});
export { pushState, replaceState, pushParams };
